







/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const MYPOSTFORUSER= createAsyncThunk(
  "MyPostForusers/MyPostForusers",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const MyPostForusersSlice = createSlice({
  name: "MyPostForusersSlice",
  initialState: {
    MyPostForusers: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfMyPostForusers: (state) => {
        state.MyPostForusers.loading = false
        state.MyPostForusers.error = false
        state.MyPostForusers.data = []
        state.MyPostForusers.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(MYPOSTFORUSER.fulfilled, (state, action) => {
      state.MyPostForusers = {
        ...state.MyPostForusers,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(MYPOSTFORUSER.pending, (state, action) => {
      state.MyPostForusers = {
        ...state.MyPostForusers,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(MYPOSTFORUSER.rejected, (state, action) => {
      state.MyPostForusers = {
        ...state.MyPostForusers,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const MyPostForusersAction = {
    MYPOSTFORUSER,
};

export { MyPostForusersAction };
export default MyPostForusersSlice.reducer;
export const {setInitialStateOfMyPostForusers} = MyPostForusersSlice.actions
